// extracted by mini-css-extract-plugin
module.exports = {"button":"UserPriceList_button__1RTBT","buttonRestore":"UserPriceList_buttonRestore__1Ir7F"};